import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowDown20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M10.75 16.1893L15.9696 10.9697L17.0303 12.0304L9.99993 19.0607L2.9696 12.0304L4.03026 10.9697L9.24999 16.1895L9.24999 1H10.75L10.75 16.1893Z'
      fill='currentColor'
    />
  </Svg>
);

ArrowDown20.displayName = 'ArrowDown20';
export default ArrowDown20;
